export function fetchUsersOnPage() {
    const onPage = [];
    const links = Array.from(document.getElementsByClassName('user-link'));
    for (const link of links){
        const username = link.getAttribute('data-username');
        const usericon = link.getAttribute('data-icon');
        const userId = link.getAttribute('data-userid');
        const userUuid = link.getAttribute('data-useruuid');
        const isGroup = link.getAttribute('data-isgroup');
        if (!username || !usericon || !userId || !userUuid || isGroup === '1') {
            continue;
        }
        // We had a bug that generated broken mention links, have to exclude them
        if (!/^\d+$/.test(userId)) {
            continue;
        }
        onPage.push({
            username,
            usericon,
            userId: parseInt(userId),
            useridUuid: userUuid,
            type: '',
            isNewDeviant: false
        });
    }
    return [
        ...new Set(onPage)
    ];
}

//# sourceMappingURL=helpers.js.map